import { useEffect, useState } from "react";
import clienteAxios from "../../../config/axios";
import AlertWarning from "../../CustomAlerts/AlertWarning";
import AlertSuccess from "../../CustomAlerts/AlertSuccess";
import { format, add, sub } from "date-fns";
import { tipoConcesion } from "../../shared/Helpers/CalculosConcesiones";
import { CuotasDetalle } from "../../../functions/Validaciones/CuotasDetalle";

import { CuotaDeuda } from "../../../functions/Validaciones/CuotaDeuda";
import { CalculoCuota } from "../../../functions/FunctionCuota";
import { FormatterNumber } from "../../../utils/formatter";
import Comprobante from "../Modals/Comprobante";
import Modal from "../../../module/modal/Modal";
import apiAxios from "../../../config/ApiAxios";
import "./PanelStyles.css";

const dateExtra = () => {
  return format(add(new Date(), { days: 1 }), "yyyy-MM-dd").toString();
};

const Panel = ({
  credito,
  setCredito,
  cuota,
  setCuota,
  pago,
  setPago,
  setSteps,
  steps,
  setForm,
  form,
  persona
}) => {
  //console.log(credito);
  //console.log(cuota);
  //Detalles credito
  const {
    id,
    detalles,
    comentarios,
    concesion,
    cuotas,
    fecha_finalizacion,
    fecha_otorgamiento,
    garante,
    interes_punitorio,
    vencimiento,
    monto,
    producto,
  } = credito;
  //Detalles cuota a pagar
  const {
    nro,
    deuda,
    capital,
    interes,
    diferencia_moratoria,
    interes_mora,
    cantidad_pagos,
    pagos,
    deuda_total,
    fecha_vencimiento,
  } = cuota;

  const [comprobante, setComprobante] = useState(false);
  const [loading, setLoading] = useState(false);
  //console.log(importe_total);
  //console.log(calculo_interes);
  //console.log(total);
  //eventos
  const enviarNotificacionJuicio = async () => {
    try {
      await apiAxios.post("/auth/notifications", {
        role: "admin",
        title: "Pago en cliente con estado Juicio",
        type: "pago_juicio",
        description: `Se cargó un pago a un cliente cuyo estado es "Juicio". Cliente: ${persona.nombre} ${persona.apellido}`,
        link: `/persona/${persona.id}`,
      });
    } catch (error) {
      console.error("Error al enviar notificación:", error);
    }
  };

  const onClick = async (e) => {
    switch (e.target.name) {
      case "notificar-juicio":
        {
          await enviarNotificacionJuicio();
          AlertSuccess({ message: "Notificación enviada al administrador" });
        }
        break;
      case "pagar":
        {
          if (form.importe == "" || form.forma_pago.trim() == "") {
            return AlertWarning({
              message: "Complete todos los datos del formulario",
              title: "Advertencia",
            });
          }
          //Validar que no se pague el total
          /*
          if(form.importe > deuda_total){
            return AlertWarning({
              message: "El importe es mayor a la totalidad de la deuda.",
              title: "Advertencia",
            });
          }
          */
          try {
            setLoading(true);
            const result = await clienteAxios.post("/Pago/add", form);
            AlertSuccess({ message: "Pago procesado!" });
            setSteps(steps + 1);
            setPago({
              pago: form,
              cuota: cuota,
            });

            // Enviar notificación si el cliente está en juicio
            if (persona?.estado === "Juicio") {
              await enviarNotificacionJuicio();
            }

            let btn = document.getElementById('btn-comprobante-pago-panel')
            btn.click();
            //console.log(form);
            //console.log(cuota);
          } catch (e) {
            setLoading(false);
            AlertWarning({
              message: "",
              title: "Danger",
            });
            return "";
          }

          console.log("aqui");
          return setComprobante(true);
        }
        break;
      case "close":
        {
          setCuota(null);
          setComprobante(false);
        }
        break;
    }
  };

  const onChange = (e) => {
    switch (e.target.name) {
      case "importe":
        {
          let importe = parseFloat(e.target.value);
          let vuelto = 0;
          let importe_cuota = 0;
          let estado = "PARCIAL";
          let prev_estado = "PARCIAL";
          //Excedentes
          let sig_cuotas = null;
          //Credito
          let status_credito = null;

          if (parseFloat(importe).toFixed(2) == parseFloat(deuda).toFixed(2)) {
            estado = "TOTAL";
            prev_estado = "TOTAL";

            //Pago a cuota actual
            importe_cuota = deuda;
          }

          if (
            Number(parseFloat(importe).toFixed(2)) >
            Number(parseFloat(deuda).toFixed(2))
          ) {
            estado = "TOTAL";
            prev_estado = "EXCEDENTE";
            //Pago a cuota actual
            importe_cuota = deuda;

            //Excedente
            let sig_importe = importe - deuda;
            //
            sig_cuotas = [];
            let stop = false;

            //Si es la ultima cuota
            if (cuotas == cuota.nro) {
              prev_estado = "TOTAL";
              estado = "TOTAL";
              importe_cuota = deuda;
              vuelto = importe - deuda;

              //Cancelar Credito
              status_credito = "Pagado";
            }

            cuota.siguientes_cuotas.map((cuota, index) => {
              //Resto
              //console.log("Deuda "+cuota.deuda);
              //console.log("Importe "+sig_importe);

              let resto = sig_importe - cuota.deuda;

              if (resto < 0 && !stop) {
                cuota.estado = "EXCEDENTE";
                cuota.importe = sig_importe;

                sig_cuotas.push(cuota);
                stop = true;
              } else {
                if (!stop) {
                  //Revisar si es la ultima cuota
                  if (cuotas == cuota.nro) {
                    cuota.estado = "TOTAL";
                    cuota.importe = cuota.deuda;

                    sig_cuotas.push(cuota);
                    sig_importe = sig_importe - cuota.deuda;
                    stop = true;

                    //Cancelar Credito
                    status_credito = "Pagado";
                  }

                  //
                  cuota.estado = "TOTAL";
                  cuota.importe = cuota.deuda;

                  sig_cuotas.push(cuota);
                  sig_importe = sig_importe - cuota.deuda;
                }
              }
            });
          }

          if (
            Number(parseFloat(importe).toFixed(2)) <
            Number(parseFloat(deuda).toFixed(2))
          ) {
            estado = "PARCIAL";
            prev_estado = "PARCIAL";
            importe_cuota = importe;
          }

          setForm({
            ...form,
            [e.target.name]: importe,
            importe_cuota: importe_cuota,
            estado: estado,
            prev_estado: prev_estado,
            fecha_importe: format(new Date(), "yyyy-MM-dd").toString(),
            credito_detalle_id: cuota.id,
            id_concesion: concesion ? concesion.id : "",
            credito_id: id,
            nro_cuota: nro,
            total_cuotas: cuotas,
            interes_punitorios: cuota.interes_mora,
            capital: cuota.capital,
            interes: cuota.interes,
            //Cuotas siguientes
            sig_cuotas: JSON.stringify(sig_cuotas),
            //Credito
            status_credito: status_credito,
          });
        }
        break;
      case "forma_pago":
        {
          setForm({
            ...form,
            [e.target.name]: e.target.value,
          });
        }
        break;
      case "judicial":
        {
          setForm({
            ...form,
            [e.target.name]: e.target.checked ? 1 : 0,
          });
        }
        break;
    }
  };
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-AR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  return (
    <div className="modern-panel">
      {/* Header */}
      <div className="panel-header">
        <i className="bi bi-credit-card-2-front me-3"></i>
        <h2>Pagar Crédito</h2>
      </div>

      {/* Alert Juicio */}
      {persona?.estado === "Juicio" && (
        <div className="alert alert-warning d-flex justify-content-between align-items-center mb-4" role="alert" style={{ borderRadius: "12px", border: "1px solid #fbbf24" }}>
          <div>
            <i className="bi bi-exclamation-triangle-fill me-2"></i>
            <strong>Juicio iniciado:</strong> Los costos pueden ser mayores a los que presenta la pantalla para cobrar.
          </div>
          <button
            className="btn btn-sm"
            style={{
              background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
              color: "white",
              border: "none",
              borderRadius: "8px",
              padding: "6px 16px",
              fontWeight: "500"
            }}
            name="notificar-juicio"
            onClick={(event) => onClick(event)}
          >
            <i className="bi bi-bell-fill me-1"></i>
            Notificar Admin
          </button>
        </div>
      )}

      {/* Form Section */}
      <div className="panel-form-section">
        <div className="row g-4">
          <div className="col-md-6">
            <div className="form-group-modern">
              <label className="form-label-modern">
                <i className="bi bi-currency-dollar me-2"></i>
                Total a Pagar
              </label>
              <input
                type="text"
                className="form-control-modern form-control-readonly"
                value={"$ " + formatCurrency(deuda)}
                disabled
                style={{ fontSize: "1.75rem", fontWeight: "700", textAlign: "center" }}
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group-modern">
              <label className="form-label-modern">
                <i className="bi bi-cash-stack me-2"></i>
                Forma de Pago
              </label>
              <select
                className="form-control-modern"
                name="forma_pago"
                onChange={(event) => onChange(event)}
                style={{ fontSize: "1.1rem" }}
              >
                <option value="">Seleccionar...</option>
                <option value="efectivo">Efectivo</option>
                <option value="tarjeta">Tarjeta</option>
                <option value="cheque">Cheque</option>
                <option value="Judicial">Judicial</option>
                <option value="Bancario">Bancario</option>
              </select>
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group-modern">
              <label className="form-label-modern">
                <i className="bi bi-check-circle me-2"></i>
                Estado del Pago
              </label>
              <input
                type="text"
                className="form-control-modern form-control-readonly"
                value={form.prev_estado}
                disabled
                style={{ textAlign: "center", fontWeight: "600" }}
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group-modern">
              <label className="form-label-modern">
                <i className="bi bi-calculator me-2"></i>
                Importe
              </label>
              <input
                type="number"
                step="0.01"
                className="form-control-modern"
                placeholder="0.00"
                name="importe"
                onChange={(event) => onChange(event)}
                value={form.importe}
                style={{ fontSize: "1.1rem" }}
              />
            </div>
          </div>
        </div>

        <button
          className="btn-pagar-modern"
          name="pagar"
          onClick={(event) => onClick(event)}
          disabled={loading}
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Procesando...
            </>
          ) : (
            <>
              <i className="bi bi-check-circle-fill me-2"></i>
              Pagar
            </>
          )}
        </button>
      </div>

      {/* Details Section */}
      <div className="row g-4 mt-2">
        {/* Credit Details */}
        <div className="col-lg-6">
          <div className="details-card">
            <div className="details-card-header">
              <i className="bi bi-file-earmark-text me-2"></i>
              Detalles del Crédito
            </div>
            <div className="details-card-body">
              <div className="detail-row">
                <span className="detail-label">Nº Crédito</span>
                <span className="detail-value">{id}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Nº Cuotas</span>
                <span className="detail-value">{cuotas}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Fecha de Otorgamiento</span>
                <span className="detail-value">
                  {format(new Date(fecha_otorgamiento), "dd/MM/yyyy")}
                </span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Fecha de Finalización</span>
                <span className="detail-value">
                  {format(new Date(fecha_finalizacion), "dd/MM/yyyy")}
                </span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Producto</span>
                <span className="detail-value">{producto}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Monto</span>
                <span className="detail-value">$ {formatCurrency(monto)}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Interés Punitorio</span>
                <span className="detail-value">{interes_punitorio}%</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Comentarios</span>
                <span className="detail-value">{comentarios || "-"}</span>
              </div>

              {concesion && (
                <div className="concesion-section">
                  <div className="concesion-header">
                    <i className="bi bi-shield-check me-2"></i>
                    Concesión {tipoConcesion(concesion.id)}
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Fecha de Pacto</span>
                    <span className="detail-value">
                      {format(new Date(concesion.fecha_alta), "dd/MM/yyyy")}
                    </span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Nuevo Vencimiento</span>
                    <span className="detail-value">
                      {concesion.inicio_vencimiento === "0000-00-00"
                        ? "Sin plazo"
                        : format(new Date(concesion.inicio_vencimiento), "dd/MM/yyyy")}
                    </span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Bonificación</span>
                    <span className="detail-value">
                      {concesion.porcentaje === 0 ? "Sin bonificación" : `${concesion.porcentaje}%`}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Installment Details */}
        <div className="col-lg-6">
          <div className="details-card">
            <div className="details-card-header">
              <i className="bi bi-calendar-check me-2"></i>
              Detalles de la Cuota
            </div>
            <div className="details-card-body">
              <div className="detail-row">
                <span className="detail-label">Nº Cuota</span>
                <span className="detail-value">{nro}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Vencimiento</span>
                <span className="detail-value">
                  {format(new Date(fecha_vencimiento), "dd/MM/yyyy")}
                </span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Días de Mora</span>
                <span className="detail-value">{diferencia_moratoria}</span>
              </div>
              <div className="detail-row-group">
                <div className="detail-col">
                  <span className="detail-label">Capital</span>
                  <span className="detail-value">$ {formatCurrency(capital)}</span>
                </div>
                <div className="detail-col">
                  <span className="detail-label">Interés</span>
                  <span className="detail-value">$ {formatCurrency(interes)}</span>
                </div>
              </div>
              <div className="detail-row">
                <span className="detail-label">Interés Punitorio</span>
                <span className="detail-value">$ {formatCurrency(interes_mora)}</span>
              </div>
              <div className="detail-row detail-row-highlight">
                <span className="detail-label">Deuda Total</span>
                <span className="detail-value">$ {formatCurrency(deuda)}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Cantidad de Pagos</span>
                <span className="detail-value">{cantidad_pagos}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Importe Total Pagado</span>
                <span className="detail-value">$ {formatCurrency(pagos)}</span>
              </div>
            </div>
          </div>
        </div>
      </div>


      <button
        className="d-none"
        id="btn-comprobante-pago-panel"
        data-bs-toggle="modal"
        data-bs-target="#comprobante-pago-panel"
      ></button>
      <Modal
        title="Comprobante de pago"
        id="comprobante-pago-panel"
        width={"800px"}
        onClose={{
          id: "btn-close-comprobante-pago-panel",
          name: "close",
          function: onClick,
        }}
        children={
          comprobante ? <Comprobante
            data={pago}
            persona={persona}
            onClick={onClick}
          />
            : ""
        }
      />
    </div>
  );
};

export default Panel;
